import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL, BASE_PAYMENT_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';
import { useParams } from 'react-router-dom';

function AdsCreate() {
    const { id } = useParams();  
    const accessToken = localStorage.getItem('accessToken'); 
    const [isUpgradeLoading, setIsUpgradeLoading] = useState(false); 
    const [from_date, setFromDate] = useState('');
    const [to_date, setToDate] = useState('');   
    const today = new Date().toISOString().split('T')[0]; 
    useEffect(() => {
        document.title = 'Infomart | Client Ads Upgrade';
    });   
    const handleSubmit = async () => {
        setIsUpgradeLoading(true); 
        await axios.post(`${BASE_URL}/vendor/ads/upgrade`, { id, from_date, to_date }, {
            headers: {  
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsUpgradeLoading(false); 
            const id = res.data.id; 
            axios.post(`${BASE_URL}/vendor/ads/payment`, { id }, {
                headers: {   
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                if (res.data.encrypted_data && res.data.access_code) { 
                    const form = document.createElement('form');
                    form.method = 'post';
                    form.action = BASE_PAYMENT_URL; 
                    const encRequestInput = document.createElement('input');
                    encRequestInput.type = 'hidden';
                    encRequestInput.name = 'encRequest';
                    encRequestInput.id = 'encRequest';
                    encRequestInput.value = res.data.encrypted_data;
                    form.appendChild(encRequestInput); 
                    const accessCodeInput = document.createElement('input');
                    accessCodeInput.type = 'hidden';
                    accessCodeInput.name = 'access_code';
                    accessCodeInput.id = 'access_code';
                    accessCodeInput.value = res.data.access_code;
                    form.appendChild(accessCodeInput); 
                    document.body.appendChild(form); 
                    form.submit(); 
                }     
            }).catch((res) => {  
                toast.error(res.response.data.msg, { autoClose: 3000 }); 
            });
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsUpgradeLoading(false);
        });  
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    <div className={styles.individualFormContainer} style={{ width: '100%' }}>
                        <div className={styles.top}> 
                            <div className="w-100">
                                <h4 className="text-left">Ads Upgrade</h4>
                            </div>  
                        </div> 
                        <div className={styles.row}>
                            <div className="col">
                                <label className="mb-2">From Date *</label>
                                <input type="date" className={inputStyles.input} min={today} onChange={e => setFromDate(e.target.value)} />
                            </div>
                            <div className="col">
                                <label className="mb-2">To Date *</label>
                                <input type="date" className={inputStyles.input} min={today} onChange={e => setToDate(e.target.value)} /> 
                            </div> 
                        </div>   
                        <div className="mt-4">
                            <BlueButton title={isUpgradeLoading ? "Loading..." : "Upgrade"} onClick={() => handleSubmit()} />
                        </div>
                    </div>  
                </div> 
            </div> 
        </div>
    );
}

export default AdsCreate;               